import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { breakpoints } from 'assets/breakpoints';

export const TabContent = styled(motion.div)`
`;

export const TabsComponent = styled.div`
  width: 100%;
  margin-bottom: -15px;
  display: flex;
  flex-direction: column;  

  @media (min-width: ${breakpoints.desktop}){
    width: 100%;
    margin-bottom: -15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const TabButtonsWrapper = styled.ul`
  padding: 0;
  margin-left: 15px;
  list-style: none;
  justify-content: space-between;
  display: flex;
  max-width: 280px;
`;

export const TabButtonItem = styled(motion.li)`
  text-align: left;
  position: relative;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
  
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    opacity: 0.2;
    position: absolute;
    border-radius: 40px;
    background: none;
    transition: background 0.5s ease;
    left: 0;
    ${(props) => props.active && 'background: #bfbfbf;'}
  }
 
  > a {
    padding: 16px;
  display: flex;
  align-items: center;
  font-size: 20px;
  overflow: hidden;
  position: relative;
  color: white;
 }
 
 > svg {
    height: 30px;
    width: 30px;
    min-width: 30px;
    fill: black;
    transition: fill 0.5s ease;
`;

export const TabText = styled(motion.span)`
  font-weight: 700;
  margin-left: 10px;
  transition: color 0.5s ease;
  width: ${(props) => (props.width ? `${props.width}px` : 'auto')}
`;

export const Icon = styled(FontAwesomeIcon)`

`;

export const TextHolder = styled.h3`
  text-align: left;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
  margin-right: 4px;
  font-size: 1rem;
`;
